
import { defineComponent } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import hemisphereService from '@/services/hemisphere.service'
import moment from 'moment'
import AddAuthorizationDialog from '@/components/AddAuthorizationDialog.vue'
import { Role, getRoleFromAuthorizationLevels } from '@/utils/role-utils'
import { useSession } from '@/composables/auth'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'

interface AuthorizationData {
  initials?: string
  fullName?: string
  email?: string
  role?: string
  roleIcon?: string
  duration?: string
  status?: string
  statusClass?: string
}

export default defineComponent({
  data() {
    return {
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      rawAuthorization: [] as any[],
      loading: false
      // authorizations: [] as AuthorizationData[]
    }
  },
  setup() {
    let { user } = useSession()
    return {
      user,
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  methods: {
    startShare() {
      const dialog: any = this.$refs.addAuthorizationDialog
      dialog.show()
    },
    async refreshAuths() {
      this.loading = true
      const buildingId = await this.getCurrentBuildingId()
      if (buildingId) {
        const response = await hemisphereService.getBuildingAuthorizations(buildingId)
        this.rawAuthorization = response.data
      }
      this.loading = false
    }
  },
  computed: {
    activeCount(): number {
      return this.authorizations.filter((a) => a.status == 'ACTIF').length
    },
    inactiveCount(): number {
      return this.authorizations.filter((a) => a.status != 'ACTIF').length
    },
    currentRole(): Role | undefined {
      let currentRole
      for (let auth of this.rawAuthorization) {
        if (!auth.active) {
          continue
        }
        if (auth.user?.email == this.user.email) {
          currentRole = getRoleFromAuthorizationLevels(auth.level, auth.hemis_level)
        }
      }
      return currentRole
    },
    authorizations(): AuthorizationData[] {
      return this.rawAuthorization.map((auth: any) => {
        const res = {} as AuthorizationData
        if (auth.user?.last_name && auth.user?.first_name) {
          res.initials = (auth.user.last_name[0] + auth.user.first_name[0]).toUpperCase()

          res.fullName = auth.user.last_name + ' ' + auth.user.first_name
        }

        res.email = auth.user?.email

        if (!auth.activated) {
          res.status = 'EN ATTENTE'
          res.statusClass = 'bg-gray-l1'
        } else if (auth.active) {
          res.status = 'ACTIF'
          res.statusClass = 'bg-green'
        } else {
          res.status = 'INACTIF'
          res.statusClass = 'bg-red'
        }

        if (auth.expiration_date && auth.expiration_date != -1) {
          res.duration = "Jusqu'au " + moment.unix(auth.expiration_date / 1000).format('DD/MM/YYYY')
        } else {
          res.duration = 'Illimité'
        }

        const role = getRoleFromAuthorizationLevels(auth.level, auth.hemis_level)
        res.role = 'roles.' + role.toLowerCase()
        res.roleIcon = 'ci-data-preview'

        return res
      })
    }
  },
  mounted() {
    this.refreshAuths()
  },
  components: {
    AddAuthorizationDialog
  }
})
